import { render, staticRenderFns } from "./media.vue?vue&type=template&id=bd1f9f68&scoped=true"
import script from "./media.vue?vue&type=script&lang=js"
export * from "./media.vue?vue&type=script&lang=js"
import style0 from "./media.vue?vue&type=style&index=0&id=bd1f9f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1f9f68",
  null
  
)

export default component.exports